import React from 'react';
import classnames from 'classnames/bind';
import styles from './LayerText.module.scss';

const cx = classnames.bind(styles);

const LayerText = ({ title, desc = undefined }) => (
	<div className={cx('area')}>
		<p className={cx('title')}>{title}</p>
		{desc && <p className={cx('desc')}>{desc}</p>}
	</div>
);

export default LayerText;
